import { ActionCellContent } from "PFApp/activities/manage_roles/parts/suggested_wm_side_panel/suggested_shortlists_table/action_column/action_cell_content";
import {
  isOpenVacancyItem,
  SuggestedWmTableItem
} from "PFApp/activities/manage_roles/parts/suggested_wm_side_panel/suggested_shortlists_table/types";

type ActionCellProps = {
  item: SuggestedWmTableItem;
};

export const ActionCell = ({ item }: ActionCellProps) => {
  if (isOpenVacancyItem(item)) {
    return null;
  }
  return <ActionCellContent item={item} />;
};
